export enum ScreenSaverMediaType {
    IMAGE = '2',
    VIDEO = '1',
}
